// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8O1xe","text":"styles_text__BPHpP","icon":"styles_icon__iNGzq","status":"styles_status__a_3Oy","removeButton":"styles_removeButton__YVSYV"};